import React, { useEffect, useRef } from "react";

const GeneralDropdown = ({
  open,
  children,
  toggleDropdown,
  dropdownStyles,
}) => {
  const ref = useRef();

  // Cierre al hacer clic fuera. No se usa useOutsideClick porque ese hook
  // mantiene el listener suscrito siempre y sin periodo de gracia: el mismo
  // clic que abre el menu sigue burbujeando hasta document y, si el efecto
  // alcanzo a suscribirse antes (cosa que depende de cuando React vacie los
  // efectos pasivos), ese listener lo lee como "clic fuera" y lo cierra en el
  // acto. El menu se monta y se desmonta dentro del mismo evento, sin llegar a
  // pintarse: se ve como si el boton no hiciera nada.
  //
  // Aqui el listener solo existe mientras el menu esta abierto y se arma un
  // macrotask despues, para que el clic que lo abrio no pueda cerrarlo.
  useEffect(() => {
    if (!open) return undefined;

    let armed = false;
    const armTimer = setTimeout(() => { armed = true; }, 0);

    const handleClick = (event) => {
      if (!armed) return;
      if (ref.current && !ref.current.contains(event.target)) toggleDropdown(false);
    };

    document.addEventListener("click", handleClick);

    return () => {
      clearTimeout(armTimer);
      document.removeEventListener("click", handleClick);
    };
  }, [open, toggleDropdown]);

  return (
    <>
      {open && (
        <div
          className={`${dropdownStyles}`}
          ref={ref}
        >
          <>{children}</>
        </div>
      )}
    </>
  );
};

GeneralDropdown.defaultProps = {
  dropdownStyles: "",
};

export default GeneralDropdown;
